import React, { useContext, useState, useEffect, useMemo } from "react";
import { Datagrid, Spinner } from "@abb/abb-common-ux-react";
import { RootContext } from "../../contexts/root-context";
import allDeviceConfig from './allDeviceConfig.json';
import './alldevices.css';

const AllDevice = () => {
  const { isAllUploaded, deviceData } = useContext(RootContext);

  const [allDeviceConfigData, setAllDeviceConfigData] = useState([]);
  const [isSpin, setIsSpin] = useState(true);
  const [error, setError] = useState(false);

  const fetchAllDeviceConfigData = async () => {
    setIsSpin(true);
    try {
      const devicesArray = deviceData?.data || [];

      const formattedData = devicesArray.map((v) => {
        let breakerStatus = v.Status;

        let badgeClass = "";
        if (breakerStatus === allDeviceConfig.breakerStatus.connectText) {
          badgeClass = "alldevice-badge-green";
        } else if (breakerStatus === allDeviceConfig.breakerStatus.disconnectText) {
          badgeClass = "alldevice-badge-red";
        } else {
          badgeClass = "alldevice-badge-orange";
        }

        return {
          fields: {
            [allDeviceConfig.fieldKeys.id]: v.ID,
            [allDeviceConfig.fieldKeys.deviceName]: v.DeviceName,
            [allDeviceConfig.fieldKeys.breakerStatus]: (
              <span className={badgeClass}>
                {breakerStatus}
              </span>
            ),
            [allDeviceConfig.fieldKeys.ipAddress]: v.IPAddress,
            [allDeviceConfig.fieldKeys.infrastructure]: v.Infrastructure,
            [allDeviceConfig.fieldKeys.plantId]: v.PlantId,
            [allDeviceConfig.fieldKeys.updatedOn]: v.LastUpdated,
          },
        };
      });

      setAllDeviceConfigData(formattedData);
      setError(false);
      setIsSpin(false);
    } catch (error) {
      console.error("device config fetch error:", error);
      setIsSpin(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchAllDeviceConfigData();
  }, [isAllUploaded, deviceData]);

  const initialColumns = useMemo(
    () => allDeviceConfig.initialColumnDefinitions,
    []
  );

  const [columns, setColumns] = useState(initialColumns);
  const [sortOrder, setSortOrder] = useState(undefined);

  const columnOrder = allDeviceConfig.columnOrder;

  // ✅ MODIFIED: Extracting the conditional rendering logic
  let contentToRender;
  if (isSpin) {
    contentToRender = <Spinner />;
  } else if (error) {
    contentToRender = <p style={{ color: "red" }}>Failed to load data.</p>;
  } else {
    contentToRender = (
      <Datagrid
        style={{
          height: "400px !important",
          width: "100%",
          overflowY: "auto !important",
        }}
        monochrome={true}
        data={allDeviceConfigData}
        columns={columns}
        onColumnReorder={(newColumns) => setColumns(newColumns)}
        rowHeight="small"
        enableSorting={true}
        sortOrder={sortOrder}
        onSort={(so) => setSortOrder(so)}
        columnOrder={columnOrder}
      />
    );
  }

  return (
    <div className="all-deevice-container">
      <h5 className="table-title">{allDeviceConfig.tableTitle}</h5>
      {contentToRender} {/* Render the extracted content */}
    </div>
  );
};

export default AllDevice;





// import React, { useState, useEffect, useMemo } from "react";
// import { Datagrid, Spinner } from "@abb/abb-common-ux-react";
// import allDeviceConfig from './allDeviceConfig.json';
// import './alldevices.css';

// const AllDevice = () => {
//   const [allDeviceConfigData, setAllDeviceConfigData] = useState([]);
//   const [isSpin, setIsSpin] = useState(true);
//   const [error, setError] = useState(false);

//   // ✅ Mock data (replaces API/context)
//   const mockDeviceData = {
//     message: "Successfully fetched 5 records for PlantId = LAB1",
//     data: [
//       {
//         DeviceName: "Zenon_Main_Server",
//         Infrastructure: "CDEC",
//         LastUpdated: "2025-06-19T07:59:00.317428",
//         IPAddress: "192.168.1.54",
//         Status: "Disconnected",
//         ID: "001",
//         PlantId: "LAB1"
//       },
//       {
//         DeviceName: "Open_PLC",
//         Infrastructure: "CDEC",
//         LastUpdated: "2025-06-19T07:59:00.555540",
//         IPAddress: "192.168.1.27",
//         Status: "Disconnected",
//         ID: "003",
//         PlantId: "LAB1"
//       },
//       {
//         DeviceName: "EL_Gateway",
//         Infrastructure: "CDEC",
//         LastUpdated: "2025-06-19T07:59:00.534363",
//         IPAddress: "192.168.1.96",
//         Status: "Disconnected",
//         ID: "002",
//         PlantId: "LAB1"
//       },
//       {
//         DeviceName: "REX615_1",
//         Infrastructure: "CDEC",
//         LastUpdated: "2025-06-19T07:59:00.575537",
//         IPAddress: "192.168.1.67",
//         Status: "Connected",
//         ID: "004",
//         PlantId: "LAB1"
//       },
//       {
//         DeviceName: "REX615_2",
//         Infrastructure: "CDEC",
//         LastUpdated: "2025-06-19T07:59:00.615587",
//         IPAddress: "192.168.1.44",
//         Status: "Connected",
//         ID: "005",
//         PlantId: "LAB1"
//       }
//     ]
//   };

//   const fetchAllDeviceConfigData = async () => {
//     setIsSpin(true);
//     try {
//       const devicesArray = mockDeviceData.data;

//       const formattedData = devicesArray.map((v) => {
//         let breakerStatus = v.Status;

//         let badgeClass = "";
//         if (breakerStatus === allDeviceConfig.breakerStatus.connectText) {
//           badgeClass = "alldevice-badge-green";
//         } else if (breakerStatus === allDeviceConfig.breakerStatus.disconnectText) {
//           badgeClass = "alldevice-badge-red";
//         } else {
//           badgeClass = "alldevice-badge-orange";
//         }

//         return {
//           fields: {
//             [allDeviceConfig.fieldKeys.id]: v.ID,
//             [allDeviceConfig.fieldKeys.deviceName]: v.DeviceName,
//             [allDeviceConfig.fieldKeys.breakerStatus]: (
//               <span className={badgeClass}>
//                 {breakerStatus}
//               </span>
//             ),
//             [allDeviceConfig.fieldKeys.ipAddress]: v.IPAddress,
//             [allDeviceConfig.fieldKeys.infrastructure]: v.Infrastructure,
//             [allDeviceConfig.fieldKeys.plantId]: v.PlantId,
//             [allDeviceConfig.fieldKeys.updatedOn]: v.LastUpdated,
//           },
//         };
//       });

//       setAllDeviceConfigData(formattedData);
//       setError(false);
//       setIsSpin(false);
//     } catch (error) {
//       console.error("device config fetch error:", error);
//       setIsSpin(false);
//       setError(true);
//     }
//   };

//   useEffect(() => {
//     fetchAllDeviceConfigData();
//   }, []); // Empty dependency for mock usage

//   const initialColumns = useMemo(
//     () => allDeviceConfig.initialColumnDefinitions,
//     []
//   );

//   const [columns, setColumns] = useState(initialColumns);
//   const [sortOrder, setSortOrder] = useState(undefined);

//   const columnOrder = allDeviceConfig.columnOrder;

//   let contentToRender;
//   if (isSpin) {
//     contentToRender = <Spinner />;
//   } else if (error) {
//     contentToRender = <p style={{ color: "red" }}>Failed to load data.</p>;
//   } else {
//     contentToRender = (
//       <Datagrid
//         style={{
//           height: "400px !important",
//           width: "100%",
//           overflowY: "auto !important",
//         }}
//         monochrome={true}
//         data={allDeviceConfigData}
//         columns={columns}
//         onColumnReorder={(newColumns) => setColumns(newColumns)}
//         rowHeight="small"
//         enableSorting={true}
//         sortOrder={sortOrder}
//         onSort={(so) => setSortOrder(so)}
//         columnOrder={columnOrder}
//       />
//     );
//   }

//   return (
//     <div className="all-deevice-container">
//       <h5 className="table-title">{allDeviceConfig.tableTitle}</h5>
//       {contentToRender}
//     </div>
//   );
// };

// export default AllDevice;
